import CampaignSummary from "./CampaignSummary";

export default CampaignSummary;
export { CampaignSummary };
